module.exports = __webpack_public_path__ + "static/media/discount.b63e0e9b.svg";